import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate, Link } from 'react-router-dom';
import "../css/Presonnel_System.css"
import P1 from '../img/P1.png'
import P2 from '../img/P2.png'
import Pay from '../img/Pay.png'
import Plus from '../img/Plus.png'
import OutOfPay from '../img/OutOfPay.png'
import Comp1 from '../img/C1.png'
import Comp2 from '../img/C2.png'
import Comp3 from '../img/C3.png'
import Comp4 from '../img/C4.png'
import Text from '../../../common/Text.js';


function Presonnel_System() {

  const [test, settest] = useState(true); 
  

  useEffect(() => {


    const options = {
        // null을 설정하거나 무엇도 설정하지 않으면 브라우저 viewport가 기준 .
        root: null,
        // 타겟 요소의 50%가 루트 요소와 겹치면 콜백을 실행
        threshold: 0.5

    };
       // Intersection Observer 인스턴스
        const observer = new IntersectionObserver(function (entries, observer) {
        
            entries.forEach(entry => {
                var tt = entry.target.children;
                // console.log('하위 갯수' + entry.target.children[0].target.classList.add('te'))
                if (entry.isIntersecting) {
                    entry.target.classList.add('testDiv_active');
                    console.log('Add active')

                    // 지연 로딩이 실행되면 unobserve 해준다.
                    // observer.unobserve(entry.target)
                }
                else {
                    //  entry.target.classList.remove('testDiv_active');
                    console.log('벗어남')
                }
            })
        }, options)


        const ims = document.querySelectorAll(".personnel_Benefits")

        ims.forEach(img => 
            observer.observe(img)
        );

      }, [])



  return (
    <div className='contentWrapper_Personnel'>
    <div className='contentWrapper_Personnel_C'>
      <div id='personnel_Title'>
        <Text variant="titlename" className="TitleP">인사제도</Text>
      </div>
      <div className='Box'>
        <div id='personnel_NameDutyTitle'>
          <Text variant="px32w700B" >호칭 및 직책 체계</Text>
          <div id='personnel_NameDutyContainer'>
            <img id='nameDutyImg' src={P1} />
            <div id='nameDutyText'>
              <div className='Personnel_NameDutyTextContainer'>
                <Text variant="px28" className='NameDutyText_Title'>팀장</Text>
                <Text variant="px28" >:</Text>
                <Text variant="px28" className='NameDutyText_Content' >팀의 목표 달성과 팀원 관리 책임을 지며, 업무 배분과 의사결정 권한을 가집니다.</Text>
              </div>
              <div className='Personnel_NameDutyTextContainer'>
                <Text variant="px28" className='NameDutyText_Title'>그룹장</Text>
                <Text variant="px28" >:</Text>
                <Text variant="px28" className='NameDutyText_Content'  >그룹 내 전략 수립과 인력 운용 권한을 가지며 팀장과의 협력 및 조정자의 역할을 합니다.</Text>
              </div>
              <div className='Personnel_NameDutyTextContainer'>
                <Text variant="px28" className='NameDutyText_Title'>라인장</Text>
                <Text variant="px28" >:</Text>
                <Text variant="px28" className='NameDutyText_Content' >업무 프로세스 및 성과 관리 책임을 지며, 프로젝트 의사 결정과 인력 관리 권한을 가집니다.</Text>
              </div>
              <div className='Personnel_NameDutyTextContainer'>
                <Text variant="px28" className='NameDutyText_Title'>프로</Text>
                <Text variant="px28" >:</Text>
                <Text variant="px28" className='NameDutyText_Content'  >직책을 맡지 않은 분들에게 모두 적용되는 호칭입니다.</Text>
              </div>
            </div>
          </div>
        </div>
        <div id='personnel_SalarySystem'>
          <Text variant="px32w700B" >연봉 체계</Text>
          <div id='personnel_SalarySystemContainer'>
            <img id='personnel_SalarySystemImg' src={P2} />

            <div id='personnel_SalarySystemImg_imgs' >
                <img src={Pay} style={{margin: "0 30px 20px 30px", width:"240px" }}/>
                <img src={Plus} style={{margin: "0 auto"}} />
                <img src={OutOfPay}  style={{margin: "30px 30px 0 30px" , width:"240px"}}/>
            </div>

            <p id='personnel_SalarySystemSubText'>
              * 부가급여는 하계 휴가비, 명절 상여금 등을 뜻함</p>
          </div>
        </div>


        {test == true ?  

        <div class='personnel_Benefits'>
          <Text variant="px32w700B" >복리 후생</Text>
            <div className='personnel_BenefitContent' style={{ borderColor : "#e6e6e6"}}>
              
                <div className='PB_container'>
                 <img className='personnel_BenefitContentImg' src={Comp1} />
                 <p className='BenefitContent_Subject'>사내문화</p>
                </div>
                <p className='BenefitContent_Expl'>유연 근무제, 기숙사 제공, 사내 동호회 활동비지원, 장기근속 포상, 자율복장</p>
            
            </div>

            <div className='personnel_BenefitContent2' style={{ borderColor : "#e6e6e6"}}>
              
              <div className='PB_container'>
               <img className='personnel_BenefitContentImg' src={Comp2} />  
               <p className='BenefitContent_Subject'>의료 지원</p>
              </div>
              <p className='BenefitContent_Expl'>의료비 지원, 종합검진비 지원, 단체상해보험, 모성보호실 운영</p>
          
          </div>

          <div className='personnel_BenefitContent3' style={{ borderColor : "#e6e6e6"}}>
              
              <div className='PB_container'>
               <img className='personnel_BenefitContentImg' src={Comp3} />
               <p className='BenefitContent_Subject'>생활 지원</p>
              </div>
              <p className='BenefitContent_Expl'>경조사 지원, 학자금 지원, 주택대부금 지원</p>
          
          </div>
          
          
          <div className='personnel_BenefitContent4' style={{ borderColor : "#e6e6e6"}}>
              
              <div className='PB_container'>
               <img className='personnel_BenefitContentImg' src={Comp4} />
               <p className='BenefitContent_Subject'>자기 개발 지원</p>
              </div>
              <p className='BenefitContent_Expl'>어학 시험 비용 지원, 품질 검사원 국제 자격증 갱신비 지원</p>
          
          </div>


        </div>
 : <div></div>}

      </div>
      </div>
    </div>
  );

}

export default Presonnel_System;